
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91id_933D3UISokMFMeta } from "/app/pages/admin/albums/[id].vue?macro=true";
import { default as draft_45_91id_93rLYrhgeB1zMeta } from "/app/pages/admin/albums/draft-[id].vue?macro=true";
import { default as index9shzUYMqpqMeta } from "/app/pages/admin/albums/index.vue?macro=true";
import { default as newBIyrwtspwVMeta } from "/app/pages/admin/albums/new.vue?macro=true";
import { default as _91id_93qUUH3pcaYXMeta } from "/app/pages/admin/dialogs/[id].vue?macro=true";
import { default as indexkAddXXk14kMeta } from "/app/pages/admin/dialogs/index.vue?macro=true";
import { default as index3Q7iSNZ65IMeta } from "/app/pages/admin/merch/index.vue?macro=true";
import { default as _91id_93bfLsQwxDkRMeta } from "/app/pages/admin/notifications/[id].vue?macro=true";
import { default as draft_45_91id_93bhMDAC2o9TMeta } from "/app/pages/admin/notifications/draft-[id].vue?macro=true";
import { default as indexgePavK9rT6Meta } from "/app/pages/admin/notifications/index.vue?macro=true";
import { default as newFMN55dhC0aMeta } from "/app/pages/admin/notifications/new.vue?macro=true";
import { default as _91id_93aqYZhs3LziMeta } from "/app/pages/admin/posts/[id].vue?macro=true";
import { default as index2RdkxBCEndMeta } from "/app/pages/admin/posts/index.vue?macro=true";
import { default as _91id_930TaVI8CGCVMeta } from "/app/pages/admin/suggests/[id].vue?macro=true";
import { default as indexPg7RGA09CTMeta } from "/app/pages/admin/suggests/index.vue?macro=true";
import { default as indexYm9dzWmM2AMeta } from "/app/pages/admin/users/index.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as _91id_93Bv15DwhtATMeta } from "/app/pages/user/suggests/[id].vue?macro=true";
import { default as draft_45_91id_93WzuKztDOHLMeta } from "/app/pages/user/suggests/draft-[id].vue?macro=true";
import { default as indexDAKIJvtOZHMeta } from "/app/pages/user/suggests/index.vue?macro=true";
import { default as newASxJs7N9BQMeta } from "/app/pages/user/suggests/new.vue?macro=true";
export default [
  {
    name: "admin-albums-id",
    path: "/admin/albums/:id()",
    component: () => import("/app/pages/admin/albums/[id].vue")
  },
  {
    name: "admin-albums-draft-id",
    path: "/admin/albums/draft-:id()",
    component: () => import("/app/pages/admin/albums/draft-[id].vue")
  },
  {
    name: "admin-albums",
    path: "/admin/albums",
    component: () => import("/app/pages/admin/albums/index.vue")
  },
  {
    name: "admin-albums-new",
    path: "/admin/albums/new",
    component: () => import("/app/pages/admin/albums/new.vue")
  },
  {
    name: "admin-dialogs-id",
    path: "/admin/dialogs/:id()",
    meta: _91id_93qUUH3pcaYXMeta || {},
    component: () => import("/app/pages/admin/dialogs/[id].vue")
  },
  {
    name: "admin-dialogs",
    path: "/admin/dialogs",
    component: () => import("/app/pages/admin/dialogs/index.vue")
  },
  {
    name: "admin-merch",
    path: "/admin/merch",
    component: () => import("/app/pages/admin/merch/index.vue")
  },
  {
    name: "admin-notifications-id",
    path: "/admin/notifications/:id()",
    component: () => import("/app/pages/admin/notifications/[id].vue")
  },
  {
    name: "admin-notifications-draft-id",
    path: "/admin/notifications/draft-:id()",
    component: () => import("/app/pages/admin/notifications/draft-[id].vue")
  },
  {
    name: "admin-notifications",
    path: "/admin/notifications",
    component: () => import("/app/pages/admin/notifications/index.vue")
  },
  {
    name: "admin-notifications-new",
    path: "/admin/notifications/new",
    component: () => import("/app/pages/admin/notifications/new.vue")
  },
  {
    name: "admin-posts-id",
    path: "/admin/posts/:id()",
    component: () => import("/app/pages/admin/posts/[id].vue")
  },
  {
    name: "admin-posts",
    path: "/admin/posts",
    component: () => import("/app/pages/admin/posts/index.vue")
  },
  {
    name: "admin-suggests-id",
    path: "/admin/suggests/:id()",
    component: () => import("/app/pages/admin/suggests/[id].vue")
  },
  {
    name: "admin-suggests",
    path: "/admin/suggests",
    component: () => import("/app/pages/admin/suggests/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("/app/pages/admin/users/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "user-suggests-id",
    path: "/user/suggests/:id()",
    component: () => import("/app/pages/user/suggests/[id].vue")
  },
  {
    name: "user-suggests-draft-id",
    path: "/user/suggests/draft-:id()",
    component: () => import("/app/pages/user/suggests/draft-[id].vue")
  },
  {
    name: "user-suggests",
    path: "/user/suggests",
    component: () => import("/app/pages/user/suggests/index.vue")
  },
  {
    name: "user-suggests-new",
    path: "/user/suggests/new",
    component: () => import("/app/pages/user/suggests/new.vue")
  }
]